/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Dashboard
 *| (C) Copyright IBM Corp. 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define([
	'../../../lib/@waca/upgrades/UpgradeBase'
], (UpgradeBase) => {

	const icon_map = {
		'announcement_16_v4': 'bullhorn',
		'api_16_v4': 'api',
		'archive_16_v4': 'archive',
		'asset_16_v4': 'microphone',
		'attachment_16_v4': 'attachment',
		'audio_16_v4': 'audio',
		'bee_16_v4': 'bee',
		'blog_16_v4': 'blog',
		'bookmark_16_v4': 'bookmark',
		'calendar_16_v4': 'calendar',
		'camera_16_v4': 'camera',
		'capability_16_v4': 'capability',
		'catalog_16_v4': 'catalog',
		'chat-message_16_v4': 'message',
		'checkout-cart_16_v4': 'checkout',
		'client_16_v4': 'client',
		'clock_24_v4': 'clock',
		'cloud_16_v4': 'cloud',
		'code_16_v4': 'code',
		'data-quality_16_v4': 'data-quality',
		'folder_16_v5': 'folder',
		'forum_16_v4': 'forum',
		'glasses_16_v4': 'glasses',
		'group_16_v5': 'group',
		'hat_16_v4': 'hat',
		'headphones_16_v4': 'headphones',
		'hills_24_v4': 'hills',
		'home_16_v4': 'home',
		'idea_16_v4': 'idea',
		'image-file_32_v4': 'image',
		'inventory_24_v4': 'inventory',
		'like_16_v4': 'like',
		'link_16_v5': 'link',
		'location_16_v5': 'location',
		'manage_16_v4': 'settings',
		'markup-pen_16_v4': 'pen',
		'mobile-phone_16_v4': 'mobile',
		'music_16_v4': 'music',
		'notifications_16_v4': 'notifications',
		'paint_24_v4': 'paint',
		'payment-card_16_v4': 'payment',
		'password-key_32_v4': 'password-key',
		'people_16_v4': 'people',
		'person_16_v4': 'person',
		'phone-call_16_v4': 'phone',
		'pin_16_v4': 'pin',
		'print_16_v4': 'print',
		'recording_16_v4': 'recording',
		'repository_16_v5': 'repository',
		'role_16_v4': 'role',
		'search_16_v5': 'search',
		'settings_16_v4': 'settings',
		'speaker_16_v4': 'speaker',
		'star-rating_16_v4': 'star',
		'tag_16_v4': 'tag',
		'thumbs-up_16_v4': 'thumbs-up',
		'thumbs-down_16_v4': 'thumbs-down',
		'tools_16_v4': 'tools',
		'traffic_16_v4': 'traffic',
		'trash_16_v4': 'trash',
		'twitter_16_v4': 'twitter',
		'unknown_16_v4': 'unknown',
		'user_16_v4': 'user',
		'venn-diagram_16_v4': 'venn-diagram',
		'video_16_v4': 'video',
		'view_16_v4': 'view',
		'warn_16_v5': 'warning',
		'watch_24_v4': 'watch',
		'watson_24_v4': 'watson',
		'wikis_16_v4': 'wikis',
		'workspace_16_v4': 'workspace',
		'world_16_v4': 'world'
	};

	class TabIconUpgrade extends UpgradeBase {

		constructor() {
			super();
			this.VERSION = 1600;
		}

		/**
		 * Perform upgrade to the tabIcon portion of the spec to replace what is
		 * there with an alias that is mapped to the correct icon.
		 *
		 *
		 * @param {object} spec - The widget spec that the upgrade is performed on
		 *
		 * @return {Promise} Promise to be resolved with upgrade performed.
		 */
		up(spec) {
			if (!spec) {
				return Promise.resolve(spec);
			}
			return this._upgradeWidgets(spec);
		}

		_upgradeWidgets(spec) {
			if(spec.layout.type === 'tab') {
				spec.layout.items.forEach(tab => {
					if(tab.tabIcon) {
						let newIcon = icon_map[tab.tabIcon.value];
						if(newIcon !== undefined) {
							tab.tabIcon = newIcon;
						} else {
							if(this.data && this.data.logger) {
								this.data.logger.warn('Unable to upgrade tab icon ' + tab.tabIcon.value + ' - replacing with default value');
							}
							delete tab.tabIcon;
						}
					}
				});
			}
			return Promise.resolve(spec);
		}
	}

	return new TabIconUpgrade();

});
